/* PawDent — קרוסלת סרטוני לקוחות. השתקה/ביטול השתקה + עצירה מחוץ למסך. */
(function () {
  'use strict';

  function initSection(root) {
    if (root.dataset.pvcInit === 'true') return;
    root.dataset.pvcInit = 'true';

    var videos = root.querySelectorAll('[data-pvc-video]');

    // כפתורי השתקה
    root.querySelectorAll('[data-pvc-mute]').forEach(function (btn) {
      var card = btn.closest('.pvc__card');
      var video = card ? card.querySelector('[data-pvc-video]') : null;
      if (!video) return;
      var onIcon = btn.querySelector('.pvc__mute-on');
      var offIcon = btn.querySelector('.pvc__mute-off');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        video.muted = !video.muted;
        var muted = video.muted;
        btn.setAttribute('aria-pressed', muted ? 'false' : 'true');
        btn.setAttribute('aria-label', muted ? 'בטל השתקה' : 'השתק');
        if (onIcon) onIcon.hidden = !muted;
        if (offIcon) offIcon.hidden = muted;
        if (!muted) {
          // כשמפעילים קול בכרטיס אחד — משתיקים את השאר
          videos.forEach(function (v) { if (v !== video) v.muted = true; });
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
      });
    });

    // עצירת וידאו כשהוא לא בתצוגה (ביצועים)
    if ('IntersectionObserver' in window && videos.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.35 });
      videos.forEach(function (v) { io.observe(v); });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-pvc]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target.querySelectorAll) return;
    e.target.querySelectorAll('[data-pvc]').forEach(function (el) {
      try { initSection(el); } catch (err) { console.error('pvc init', err); }
    });
  });
})();
